export const employeeConstants = {
    
    ADD_EMPLOYEE_REQUEST: 'ADD_EMPLOYEE_REQUEST',
    ADD_EMPLOYEE_SUCCESS: 'ADD_EMPLOYEE_SUCCESS',
    ADD_EMPLOYEE_FAILURE: 'ADD_EMPLOYEE_FAILURE',

    GET_EMPLOYEES_REQUEST: "GET_EMPLOYEES_REQUEST",
    GET_EMPLOYEES_SUCCESS: "GET_EMPLOYEES_SUCCESS",
    GET_EMPLOYEES_FAILURE: "GET_EMPLOYEES_FAILURE",

    EDIT_EMPLOYEE_REQUEST: 'EDIT_EMPLOYEE_REQUEST',
    EDIT_EMPLOYEE_SUCCESS: 'EDIT_EMPLOYEE_SUCCESS',
    EDIT_EMPLOYEE_FAILURE: 'EDIT_EMPLOYEE_FAILURE',

    DELETE_EMPLOYEE_REQUEST: 'DELETE_EMPLOYEE_REQUEST',
    DELETE_EMPLOYEE_SUCCESS: 'DELETE_EMPLOYEE_SUCCESS',
    DELETE_EMPLOYEE_FAILURE: 'DELETE_EMPLOYEE_FAILURE',
    
    GET_PERMISSIONS_REQUEST: 'GET_PERMISSIONS_REQUEST',
    GET_PERMISSIONS_SUCCESS: 'GET_PERMISSIONS_SUCCESS',
    GET_PERMISSIONS_FAILURE: 'GET_PERMISSIONS_FAILURE',

    GET_APPLICATIONS_REQUEST: 'GET_APPLICATIONS_REQUEST',
    GET_APPLICATIONS_SUCCESS: 'GET_APPLICATIONS_SUCCESS',
    GET_APPLICATIONS_FAILURE: 'GET_APPLICATIONS_FAILURE',

    ADD_APPLICATION_REQUEST: 'ADD_APPLICATION_REQUEST',
    ADD_APPLICATION_SUCCESS: 'ADD_APPLICATION_SUCCESS',
    ADD_APPLICATION_FAILURE: 'ADD_APPLICATION_FAILURE',

    EDIT_APPLICATIONS_REQUEST: 'EDIT_APPLICATIONS_REQUEST',
    EDIT_APPLICATIONS_SUCCESS: 'EDIT_APPLICATIONS_SUCCESS',
    EDIT_APPLICATIONS_FAILURE: 'EDIT_APPLICATIONS_FAILURE'

};
